var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"delivery-stage-type"},[_c('div',[_vm._v(_vm._s(_vm.formattedPickupAt))]),(_vm.deliveryBy)?_c('div',[_vm._v(" --- "),_c('br'),_c('delivery-by',{attrs:{"delivery-by":_vm.deliveryBy,"status":_vm.status,"isCancelled":_vm.isCancelled}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }